import { ApiService } from '../../common'

export class AppPrintsApi extends ApiService {}
